import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {DefaultFilter} from '@mominsamir/ngx-smart-table';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {GeneralOption} from '@core/interfaces/system/system-common';

@Component({
    template: `
        <div class="form-container">
            <ngx-select
                [multiple]="true"
                [placeholder]="placeholder"
                [formControl]="inputControl"
                [options]="options"
                [showSelectAll]="!removeSelectAll"
                [showClearButton]="false"
            ></ngx-select>
            <span class="amount" *ngIf="inputControl?.value?.length">
                {{ getLengthSelected(inputControl.value) }}
            </span>
        </div>
    `,
    styleUrls: ['./multi-select-filter.component.scss'],
})
export class MultiSelectFilterComponent extends DefaultFilter implements OnInit, OnChanges, OnDestroy {
    options: GeneralOption[] = [];

    inputControl = new FormControl([]);

    placeholder: string = 'Select...';

    _onDestroy = new Subject();

    selectAllValue: string[];

    removeSelectAll = false;

    constructor() {
        super();
    }

    ngOnInit() {
        this.inputControl.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(1000), takeUntil(this._onDestroy))
            .subscribe((value: string[]) => {
                if (this.selectAllValue && !value.length) value = this.selectAllValue;
                let result = '';
                value.forEach((item) => {
                    if (item) {
                        if (result === '') result += `${item}`;
                        else result += `|${item}`;
                    }
                });

                this.query = result;
                this.setFilter();
            });

        this.options = this.column.filter.config?.options || [];
        this.selectAllValue = this.column.filter.config?.selectAllValue;
        this.removeSelectAll = this.column.filter.config?.removeSelectAll;
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.source && this.inputControl) {
            this.inputControl.reset([]);
        }
        if (changes.query) {
            this.query = changes.query.currentValue;
            this.inputControl.setValue(this.inputControl.value);
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    // Get length, but without the 'All' option counted as an item
    getLengthSelected(options: any[]) {
        return options.filter((o) => o != 0 && o != '' && o != 'All').length;
    }
}
